var _defs, _path, _circle, _path2, _circle2, _text, _path3, _path4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPra360Logo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 850.72 165.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e64c1c;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        letter-spacing: .45em;\n      }\n\n      .cls-6 {\n        font-family: AesteticoFormal-Regular, 'Aestetico Formal';\n        font-size: 75.12px;\n      }\n\n      .cls-6, .cls-3 {\n        fill: #222c58;\n      }\n\n      .cls-2 {\n        fill: #eb831a;\n      }\n\n      .cls-7 {\n        fill: none;\n        stroke: #222c58;\n        stroke-miterlimit: 10;\n        stroke-width: 2.34px;\n      }\n\n      .cls-4 {\n        fill: #1475d6;\n      }\n\n      .cls-8 {\n        letter-spacing: .48em;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m579.16,112.88c14.37,0,26.02-11.65,26.02-26.02,0-14.37-11.65-26.02-26.02-26.02h-30.39c-14.37,0-26.02,11.65-26.02,26.02,0,14.37,11.65,26.02,26.02,26.02h30.39Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 664.29,
    cy: 87.7,
    r: 38.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m765.9,106.27c-11.41,0-21.52-6.28-27.72-15.94,6.2-9.65,16.31-15.94,27.72-15.94s21.52,6.28,27.72,15.94c-6.2,9.65-16.31,15.94-27.72,15.94Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 682.79,
    cy: 67.66,
    r: 38.54
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(66.25 109.52)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 0,
    y: 0
  }, "PR"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 152.57,
    y: 0
  }, "A"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m344.33,101.48c0,15.26-10.78,22.88-26.65,22.88-10.98,0-18.5-2.64-22.87-6.61l6.51-10.88c3.76,3.15,7.63,4.88,15.96,4.88,7.32,0,13.42-2.55,13.42-9.76,0-6-3.45-9.26-11.19-9.26-3.55,0-6.8.61-8.94,1.42l-6.62-8.34,19.02-17.18h-26.14v-13.83h43.93v12.3l-16.58,14.84h.41c12.71,0,19.73,7.42,19.73,19.53Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m409.71,100.89c0,16.68-11.5,23.59-24.71,23.59-16.07,0-26.65-9.76-26.65-33.25,0-25.43,13.12-37.42,29.69-37.42,7.84,0,13.94,2.03,18.82,6.1l-6.2,10.58c-4.68-3.46-8.54-4.17-12.1-4.17-6.92,0-14.55,3.76-15.76,20.13,4.97-4.57,10.36-6.1,16.67-6.1,12.51,0,20.25,7.32,20.25,20.54Zm-13.23,1.23c0-7.32-4.67-9.87-10.67-9.87-5.19,0-9.67,2.03-12.92,4.88,1.23,10.17,5.69,15.36,13.12,15.36,6.91,0,10.47-3.66,10.47-10.37Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m420.17,89.73c0-20.18,11.02-35.48,29.41-35.48s29.53,12.93,29.53,34.82c0,20.45-10.79,35.75-29.53,35.75s-29.41-13.32-29.41-35.09Zm46.53-.26c0-13.32-5.53-22.43-17.12-22.43s-16.77,8.84-16.77,22.43,5.08,22.43,16.77,22.43,17.12-8.71,17.12-22.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m485.98,69.25c0-8.92,5.23-15.26,13.64-15.26s13.56,5.4,13.56,14.79-5.31,15.17-13.64,15.17-13.56-5.41-13.56-14.7Zm18.47-.19c0-5.12-1.72-7.58-4.83-7.58s-4.89,2.46-4.89,7.58,1.79,7.4,4.89,7.4,4.83-2.18,4.83-7.4Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPra360Logo);
export default __webpack_public_path__ + "static/media/PRA_360_LOGO.873a14cdc8f2a816127840271087d3a0.svg";
export { ForwardRef as ReactComponent };